import { fetchEndpoint } from '../server/network';

// 登录
export const authSignin =
(username, password) =>
fetchEndpoint(
  '/v2/ecapi.auth.signin',
  'POST',
  {
    "username": username,  // 用户名/手机号/email
    "password": password,  // 密码
    "device_id": window.device_id
  }
)




// WEBPACK FOOTER //
// ./src/api/auth-base.js